export const applyStates = {
  revoked: {
    value: 0,
    name: '已撤回',
    timeLabel: '撤回时间',
    personLabel: '撤回者',
    tagType: 'info',
  },
  passed: {
    value: 1,
    name: '已通过',
    timeLabel: '通过时间',
    personLabel: '通过者',
    tagType: 'success',
  },
  review: {
    value: 2,
    name: '待审核',
    tagType: 'warning',
  },
  rejected: {
    value: 3,
    name: '已驳回',
    timeLabel: '驳回时间',
    personLabel: '驳回者',
    tagType: 'danger',
  },
};

export function findApplyState(value) {
  for (const key in applyStates) {
    if (value === applyStates[key].value) return [applyStates[key]];
  }
}
